import axios from 'axios';
import { message } from 'antd';
import localStorage from '../../utils/localStorage';
import moment from 'moment';
import {
  API_AUTH,
  API_DEVICE,
  API_DEVICETYPE,
  API_DEVICEPARAMETER,
  API_HIERARCHYMODULE,
  API_MAINTAINENECE,
  API_MASTERCONFIGURATION,
  API_RULEENGINE,
  GETUSERLIST
} from '../../commons/api';
/**this function is for save rule and param is json  payload  */
export async function saveRule(param) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const saveRule = {
    method: 'POST',
    url: `${API_RULEENGINE.CREATE}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: { ...param, SiteId: siteId }
  };
  
  return axios(saveRule)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response) {
        switch (err.response.status) {
          case 400:
            message.info(err.response.data.message);
            break;
          case 413:
            message.error('The Uploaded Data is too large. Please reduce the size and try again.');
            break;
          case 500:
            message.info(err.response.data.message);
            break;
          default:
            message.error('An Unexpected error occurred.');
        }
      } else {
        message.error('Network error. Please try again.');
      }
    });
}
/**this function is to get the rule list created by user based on siteID */
export async function ruleList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const ruleList = {
    method: 'GET',
    url: `${API_RULEENGINE.GET}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(ruleList)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}

export async function getAIRulesList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `${API_RULEENGINE.GET}?SiteId=${siteId}&AIRule=${true}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
}
export async function ruleListForDeviceType() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const ruleList = {
    method: 'GET',
    url: `${API_RULEENGINE.GET}?SiteId=${siteId}&ruleType=deviceType`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(ruleList)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}

export async function getRules() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/ruleGenerator/get?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
}

export async function aiDeleteRule(recordId) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: `DELETE`,
    url: `/api/ruleGenerator/delete?SiteId=${siteId}&Id=${recordId.Id}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
}

export async function getRuleCounts() {
  // return {
  //   ActiveCount: 23,
  //   InActiveCount: 82,
  //   TotalCount: 105
  // };

  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  let Authorization = 'Bearer ' + token;
  const ruleList = {
    method: 'GET',
    url: `${API_RULEENGINE.GetStatusCount}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(ruleList)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
/**this function is for get the rule details based on ID for edit or update purpose  */
export async function ruleListID(Id) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const getById = {
    method: 'GET',
    url: `${API_RULEENGINE.GET}?SiteId=${siteId}&Id=${Id}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(getById);
}
/**this function is for update the rule   */
export async function editRule(key, payLoad) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  let Authorization = 'Bearer ' + token;

  const updateRule = {
    method: 'PATCH',
    url: `${API_RULEENGINE.UPDATE}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: { ...payLoad, SiteId: siteId, Id: parseInt(key) }
  };

  return axios(updateRule)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response) {
        switch (err.response.status) {
          case 400:
          case 500:
            message.info(err.response.data.message);
            break;
          case 413:
            message.error('The Uploaded Data is too large. Please reduce the size and try again.');
            break;
          default:
            message.error('An Unexpected error occurred.');
        }
      } else {
        message.error('Network error. Please try again.');
      }
    });
}
/**this function is for delete the rule  based on rule id  */
export async function deleteRule(key) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const deleteRule = {
    method: 'DELETE',
    url: `${API_RULEENGINE.DELETE}?SiteId=${siteId}&Id=${parseInt(key)}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(deleteRule)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
/**this function purpose to get the Device List */
export async function deviceList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const deciceListApi = {
    method: 'POST',
    url: `${API_DEVICE.CACHE}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      Module: '',
      SiteId: siteId
    }
  };
  return axios(deciceListApi)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}

export async function deviceTypeListData() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const deviceTypeListApi = {
    method: 'GET',
    url: `${API_DEVICETYPE.GET}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(deviceTypeListApi)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
export async function getCommunicationList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const deciceListApi = {
    method: 'POST',
    url: `${API_MASTERCONFIGURATION.Master}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      MasterCode: 'Notification_Types',
      ActionType: 'read',
      Type: 'WithSiteId',

      Conditions: [
        {
          key: 'Status',
          value: true
        },
        {
          key: 'Module',
          value: 'RuleEngine'
        }
      ]
    }
  };
  return axios(deciceListApi)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
export async function getparameterChangeList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const parameterChangeList = {
    method: 'GET',
    url: `${API_DEVICEPARAMETER.GetParameterTypes}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(parameterChangeList)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}

export async function getDeviceData(param, hierarchycode) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const deciceListApi = {
    method: 'POST',
    url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      ParameterType: param,
      HierarchyCode: hierarchycode
    }
  };
  return axios(deciceListApi)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
export async function getUserHierarcy() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const deciceListApi = {
    method: 'GET',
    url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(deciceListApi)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}

export async function getUserprofiles() {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');

  const deciceListApi = {
    method: 'GET',
    url: `${API_AUTH.ME}?SiteId=${siteId}&menuType=Web`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(deciceListApi)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}

export async function getHierarchyLevels(HierarchyCode, ParameterType) {
  const accessToken = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let headers = {
    method: 'GET',
    url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?HierarchyCode=${HierarchyCode}&ParameterType=${ParameterType}&SiteId=${siteId}`,
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  };
  return axios(headers)
    .then(({ data }) => {
      return data;
    })
    .catch(function (error) {
      console.log(error);
    });
}

/**this function purpose to get the Equipment Type List */
export async function deviceTypeList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const deciceListApi = {
    method: 'POST',
    /**this url for device TypeList */
    url: `${API_DEVICE.GetDeviceTypes}`,

    headers: {
      Authorization: Authorization
    },
    data: {
      Module: '',
      SiteId: siteId
    }
  };
  return axios(deciceListApi)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
/**this function purpose is to get recipient or user list for mail ID purpose */
export async function recipientListAPI() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  let Authorization = 'Bearer ' + token;
  const recipientListApi = {
    method: 'GET',
    url: `${GETUSERLIST.GET}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(recipientListApi)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}

// export async function getEquipmentList() {
//   const siteId = localStorage.get('currentSite');
//   const token = localStorage.get('accessToken');

//   let Authorization = 'Bearer ' + token;

//   const getEquipmentListPayload = {
//     method: 'GET',
//     url: `${API_DEVICE.GET}?SiteId=${siteId}`,
//     headers: {
//       Authorization: Authorization
//     }
//   };
//   return axios(getEquipmentListPayload)
//     .then((response) => {
//       return response.data;
//     })
//     .catch(() => {
//       return [];
//     });
// }

export async function getParamtersListWithType() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  let Authorization = 'Bearer ' + token;
  const parameterListApi = {
    method: 'GET',
    url: `${API_DEVICEPARAMETER.GetParametersByType}?SiteId=${siteId}&Type=RuleEngine`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(parameterListApi)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
/**this funtion is to get the list of parametbased on seleted Equipment ID  */
export async function getparameterList(device, parameter) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  let Authorization = 'Bearer ' + token;
  const parameterListApi = {
    method: 'POST',
    url: `${API_DEVICE.GetDeviceParamsByType}?SiteId=${siteId}`,
    data: {
      Device: device,
      ParameterType: parameter
    },
    headers: {
      Authorization: Authorization
    }
  };
  return axios(parameterListApi)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
export async function getparameterListByDeviceType(ParameterType, DeviceType) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  let Authorization = 'Bearer ' + token;
  const parameterListApi = {
    method: 'GET',
    url: `/api/client/parameter/deviceParamList?SiteId=${siteId}&Type=Parameter&ParameterType=${ParameterType}&DeviceType=${DeviceType}`,

    headers: {
      Authorization: Authorization
    }
  };
  return axios(parameterListApi)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
/**this function purpose is to get REST API list */
export async function urlList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const urlListApi = {
    method: 'GET',
    url: `${API_RULEENGINE.GetRestApiList}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(urlListApi)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
}
/**this function purpose is to either enable or disable the rule to trigger notifications  */
export async function updateNotificationStatus(payload) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const upateRuleStatus = {
    method: 'POST',
    url: `${API_RULEENGINE.UpdateNotificationStatus}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: { ...payload, SiteId: siteId }
  };
  return axios(upateRuleStatus)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
/**this function purpose is to either enable or disable the rule to trigger notifications  */
export async function updateRuleStatus(payload) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const upateRuleStatus = {
    method: 'PATCH',
    url: `${API_RULEENGINE.UpdateRuleStatus}?SiteId=${siteId}&RuleStatus=${payload.RuleStatus}&Id=${payload.Id}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(upateRuleStatus)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
/** this function is get noDevice parameters list*/
export async function nodeviceParameterList(deviceListData) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;

  const nodeviceparameterList = {
    method: 'GET',
    url: `${API_RULEENGINE.GetNonDeviceParametersList}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      deviceListData
    }
  };
  // return axios(nodeviceparameterList)
  return axios(nodeviceparameterList)
    .then((response) => {
      return response.data;
    })
    .catch(function () {});
}

export async function tablesList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;

  const tableList = {
    method: 'GET',
    url: `${API_RULEENGINE.GetTableList}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(tableList)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
}

export async function getColumnsList(tables) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const columnList = {
    method: 'POST',
    url: `${API_RULEENGINE.GetColumnList}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      tableId: tables
    }
  };
  return axios(columnList)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
/**this function purpose is get the cronJob frequency list which was usingon batch Type */
export async function priorityList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const frequencyList = {
    method: 'GET',
    url: `${API_RULEENGINE.GetPriorityList}?SiteId=${siteId}&RuleType=${'batch'}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(frequencyList)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
}
/**this function purpose is to get the rule trigger list based on rule selection */
export async function getRuleExecutionInfo(ruleId, value) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const getRuleExecutionInfo = {
    method: 'POST',
    url: `${API_RULEENGINE.GetRuleEngineLogs}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      RuleId: ruleId,
      StartDate: moment(value[0]).format('YYYY-MM-DD HH:mm'),
      EndDate: moment(value[1]).format('YYYY-MM-DD HH:mm'),
      SiteId: siteId,
      SourceType: 'RuleEngine'
    }
  };
  return axios(getRuleExecutionInfo)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
/**this function purpose is to give  the feedback for already excuted or notification trigger rules */
export async function saveFeedback(feedBackInfo) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const saveFeedback = {
    method: 'POST',
    url: `${API_RULEENGINE.SaveFeedbackData}?SiteId=${siteId}`,
    data: feedBackInfo,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(saveFeedback)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        message.success(response.data.message);
      } else {
        message.error(response.data.message);
      }
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}

export async function getfeedBackInfo(ruleId) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');

  let Authorization = 'Bearer ' + token;
  const getRuleExecutionInfo = {
    method: 'GET',
    url: `${API_RULEENGINE.GetFeedbackList}?StatusId=${ruleId}&SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(getRuleExecutionInfo)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
export async function getWarningTypes() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const getWarningTypes = {
    method: 'GET',
    url: `${API_RULEENGINE.GetWarningTypes}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(getWarningTypes)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
/**this function purpose is to updated  the feedback  */
export async function updateFeedBack(feedBackInfo) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;
  const getRuleExecutionInfo = {
    method: 'POST',
    url: `${API_RULEENGINE.UpdateFeedback}?SiteId=${siteId}`,
    data: feedBackInfo,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(getRuleExecutionInfo)
    .then((response) => {
      if (response && response.status && response.status === 200) {
        message.success(response.data.message);
      } else {
        message.error(response.data.message);
      }
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}
/**this function purpose is to get the rootcause  list based on rule executation */
export async function getRootCauseInfo(ruleData) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const getRootCauseInfo = {
    method: 'POST',
    url: `${API_RULEENGINE.GetRootCause}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      DeviceId: ruleData.DeviceId,
      StartDate: moment(ruleData.selectedDate.startDate).format('YYYY-MM-DD HH:mm'),
      EndDate: moment(ruleData.selectedDate.endDate).format('YYYY-MM-DD HH:mm '),

      ParameterCode: ruleData.ParameterCode,
      WarningType: ruleData.WarningType,

      SiteId: siteId
    }
  };
  return axios(getRootCauseInfo)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}

export async function getRuleType() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const getRootCauseInfo = {
    method: 'GET',
    url: `${API_RULEENGINE.GetRuleTypes}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(getRootCauseInfo)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}

export async function getGroupList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const getGroup = {
    method: 'POST',
    url: `${API_MASTERCONFIGURATION.Master}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    },
    data: {
      MasterCode: 'Rule_Groups',
      ActionType: 'read',
      Type: 'WithSiteId',
      Conditions: [
        {
          key: 'SiteId',
          value: siteId
        }
      ]
    }
  };
  return axios(getGroup)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response.status === 400 || err.response.status === 500) {
        message.info(err.response.data.message);
      }
    });
}

export async function getMaintainenceList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `${API_MAINTAINENECE.GET}?SiteId=${siteId}`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
}

export async function getDeviceListByFilters(deviceObject) {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/client/parameter/deviceParamList?SiteId=${siteId}&DeviceType=${deviceObject.DeviceType}&ParameterType=${deviceObject.ParameterType}&Type=Device`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
}

export async function getDeviceTypeExclusionList() {
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');

  let Authorization = 'Bearer ' + token;
  const header = {
    method: 'GET',
    url: `/api/ruleEngine/get?SiteId=${siteId}&ruleType=deviceType&ExcludeList=true`,
    headers: {
      Authorization: Authorization
    }
  };
  return axios(header)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err && err.response && (err.response.status === 400 || err.response.status === 500)) {
        message.info(err.response.data.message);
      }
    });
}
export async function saveMaintainance(payload) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;

  const saveMaintainance = {
    method: 'POST',
    url: `${API_MAINTAINENECE.CREATE}?SiteId=${siteId}`,
    data: payload,
    headers: {
      Authorization: Authorization
    }
  };

  return axios(saveMaintainance)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response) {
        switch (err.response.status) {
          case 400:
          case 500:
            message.info(err.response.data.message);
            break;
          default:
            message.error('An Unexpected error occurred.');
        }
      } else {
        message.error('Network error. Please try again.');
      }
    });
}
export async function updateMaintainance(payload) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;

  const updateMaintainance = {
    method: 'PATCH',
    url: `${API_MAINTAINENECE.UPDATE}?SiteId=${siteId}&Id=${payload.Id}`,
    data: payload,
    headers: {
      Authorization: Authorization
    }
  };

  return axios(updateMaintainance)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response) {
        switch (err.response.status) {
          case 400:
          case 500:
            message.info(err.response.data.message);
            break;
          default:
            message.error('An Unexpected error occurred.');
        }
      } else {
        message.error('Network error. Please try again.');
      }
    });
}
export async function updateRuleExclusion(payload) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;

  const updateExclusion = {
    method: 'PATCH',
    url: `/api/ruleEngine/updateExclude?SiteId=${siteId}`,
    data: payload,
    headers: {
      Authorization: Authorization
    }
  };

  return axios(updateExclusion)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      if (err.response) {
        switch (err.response.status) {
          case 400:
          case 500:
            message.info(err.response.data.message);
            break;
          default:
            message.error('An Unexpected error occurred.');
        }
      } else {
        message.error('Network error. Please try again.');
      }
    });
}
export async function deleteMaintainance(Id) {
  const token = localStorage.get('accessToken');
  const siteId = localStorage.get('currentSite');
  let Authorization = 'Bearer ' + token;

  const deleteMaintainanceRequest = {
    method: 'DELETE',
    url: `${API_MAINTAINENECE.DELETE}?SiteId=${siteId}&Id=${Id}`,
    headers: {
      Authorization: Authorization
    }
  };

  return axios(deleteMaintainanceRequest)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err.response) {
        switch (err.response.status) {
          case 400:
          case 500:
            message.info(err.response.data.message);
            break;
          default:
            message.error('An Unexpected error occurred.');
        }
      } else {
        message.error('Network error. Please try again.');
      }
    });
}